import React, { useState } from 'react';
import { usePDF } from '../context/PDFContext';
import {
  Scissors,
  Merge,
  Type,
  Image as ImageIcon,
  Highlighter,
  FileSignature,
  RotateCw,
  Trash2,
  Minimize2,
  Droplet,
  Eraser,
} from 'lucide-react';
import { Button } from './ui/button';
import { Separator } from './ui/separator';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const tools = [
  { id: 'split', label: 'Split', icon: Scissors },
  { id: 'merge', label: 'Merge', icon: Merge },
  { id: 'text', label: 'Add Text', icon: Type },
  { id: 'erase', label: 'Erase Text', icon: Eraser },
  { id: 'image', label: 'Add Image', icon: ImageIcon },
  { id: 'highlight', label: 'Highlight', icon: Highlighter },
  { id: 'signature', label: 'Signature', icon: FileSignature },
  { id: 'rotate', label: 'Rotate', icon: RotateCw },
  { id: 'delete', label: 'Delete Pages', icon: Trash2 },
  { id: 'compress', label: 'Compress', icon: Minimize2 },
  { id: 'watermark', label: 'Watermark', icon: Droplet },
];

const Toolbar = () => {
  const { currentTool, setCurrentTool, pdfInfo, isLocked } = usePDF();

  if (!pdfInfo) {
    return null;
  }

  return (
    <div
      data-testid="toolbar"
      className="border-b border-border bg-surface px-2 sm:px-4 py-1.5 sm:py-2 flex items-center gap-0.5 sm:gap-1 overflow-x-auto shrink-0"
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      <TooltipProvider>
        {tools.map((tool, index) => (
          <React.Fragment key={tool.id}>
            {(index === 2 || index === 7 || index === 9) && <Separator orientation="vertical" className="h-6 mx-0.5 sm:mx-1 shrink-0" />}
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  data-testid={`tool-${tool.id}`}
                  variant={currentTool === tool.id ? 'default' : 'ghost'}
                  size="sm"
                  disabled={isLocked}
                  className="h-11 w-11 lg:h-9 lg:w-9 p-0 rounded-md active:scale-95 transition-all shrink-0 disabled:opacity-40"
                  onClick={() => setCurrentTool(tool.id)}
                >
                  <tool.icon className="w-[18px] h-[18px] lg:w-4 lg:h-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>{tool.label}</p>
              </TooltipContent>
            </Tooltip>
          </React.Fragment>
        ))}
      </TooltipProvider>
    </div>
  );
};

export default Toolbar;